export default {
  metaTitle: '发运单',
  titlePage: '发运单列表',
  orderStatus: '订单状态',
  payment: '支付方式',
  userId: '用户ID',
  account: '用户帐号',
  userPhone: '用户电话',
  addrPhone: '收件电话',
  so: '订单ID',
  packageSerial: '发运包序号',
  shipOrderSerial: '发运单序号',
  sku: 'SKU ID',
  listingId: 'Listing ID',
  shipPackage: '发运包',
  paymentList1: '所有',
  paymentList2: '在线支付',
  paymentList3: '货到付款',
  paymentList4: '预付款',
  // -------------------------
  PackageStates1: '待发货',
  PackageStates2: '待派送',
  PackageStates3: '派送中',
  PackageStates4: '已关闭',
  PackageStates5: '已取消',
  PackageStates6: '已完成',
  PackageStates7: '已拒收',
  PackageStates8: '所有',
  PackageStates9: '已退回',
  // -----------------------
  packageShort1: '待发货',
  packageShort2: '待派送',
  packageShort3: '派送中',
  packageShort4: '关闭',
  packageShort5: '取消',
  packageShort6: '完成',
  packageShort7: '拒收',
  packageShort8: '所有',
  packageShort9: '退回',
  // -------------------------------
  dates1: '昨天',
  dates2: '今天',
  dates3: '7日内',
  dates4: '30日内',
  dates5: '3月内',
  dates6: '最近1年内',
  dates7: '所有',
  // -----------------注：下方数据为上面的简写
  dateShort1: '昨天',
  dateShort2: '今天',
  dateShort3: '7天',
  dateShort4: '30天',
  dateShort5: '3月内',
  dateShort6: '最近1年内',
  dateShort7: '所有',
  // -------------------
  orderconditions1: '创建时间',
  orderconditions2: '发运包生成时间',
  orderconditions3: '完成时间',
  orderconditions4: '关闭时间',
  // -----------------------------
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  // --------------------------
  paymentMethodMap1: '在线支付',
  paymentMethodMap2: '货到付款',
  paymentMethodMap3: '预付款',
  // -----------------------------
  packageStatusMap1: '待发货',
  packageStatusMap2: '运输中',
  packageStatusMap3: '派送中',
  packageStatusMap4: '已完成',
  packageStatusMap5: '派送中',
  packageStatusMap6: '已拒收',
  packageStatusMap7: '已取消',
  packageStatusMap8: '已退回',
  // -----------------------------
  columnShipPackage1: '发运包',
  columnShipPackage2: '发运单中包含',
  columnShipPackage3: '订单ID',
  columnShipPackage4: '支付方式',
  columnShipPackage5: '创建时间',
  columnShipPackage6: '用户ID',
  columnShipPackage7: '支付余量',
  columnShipPackage8: '在线支付',
  columnShipPackage9: '状态',
  columnShipPackage10: '打印时间',
  columnShipPackage11: '物流单号',
  // --------------------------------------
  columnsFile1: '店铺',
  columnsFile2: '联系电话',
  shippackagelist: '发运包列表',
  // ---------批量填写国内运单-----------
  batchselection: '为国内运单填写批量选择',
  fillInBatches: '批量填写国内运单号',
  printBatches: '批量打印面单',
  waybillTitle1: '为选择的',
  waybillTitle2: '个订单批量填写国内运单',
  assign: '请将包裹发送到指定中转仓',
  location: '所在地',
  warehousesName: '中转仓名称',
  contact: '联系人',
  phone: '电话',
  address: '收货地址',
  batchFillIn: '批量填写',
  errTips: '请先选择快递公司并填写国内运单号',
  waybillNumber: '国内运单号',
  editwaybill: '修改运单信息',
  submit: '确定发货'

}
